import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

export const authCodeFlowConfig: AuthConfig = {
  // auth service configuration for auth code flow
    redirectUri: environment.redirectURI,
    responseType: 'code',
    issuer: environment.issuerURI,
    strictDiscoveryDocumentValidation: false,
    tokenEndpoint: environment.token_endpoint,
    loginUrl: environment.token_endpoint,
    logoutUrl: environment.logout_endpoint,
    clientId: environment.clientId,
    scope: environment.scopeUrl,
    customQueryParams: {prompt: 'login'},
    oidc: true,
    useIdTokenHintForSilentRefresh: false,
    skipIssuerCheck: true,
    clearHashAfterLogin: true
  };


